'use strict';

/**
 * Extends resource model(s) with sync methods
 */

var Util = require('../Util');
var Syncify = require('../Syncify');


var _recordedTimestamps = {};

module.exports = {

  /**
   * Retrieve the model sync trigger definitions specified when the resource was created
   *
   * @return {Array|Object|undefined}
   */
  $getSyncTriggers: function $getSyncTriggers () {
    return this.$options.syncTriggers && this.$options.syncTriggers.model;
  },

  attachSyncListeners: function attachSyncListeners (id, callback) {

    var resourceName = this.$name;
    var syncTriggers = this.$getSyncTriggers();

    if (syncTriggers) {
      var triggers = Util.formatDefinition(syncTriggers, {
        modelId: id
      });

      Syncify.addSyncListeners(resourceName, triggers, this.$sync.bind(this, id, callback));
    }
  },

  detachSyncListeners: function detachSyncListeners (id) {

    var resourceName = this.$name;
    var syncTriggers = this.$getSyncTriggers();

    if (syncTriggers) {
      var triggers = Util.formatDefinition(syncTriggers, {
        modelId: id
      });

      Syncify.removeSyncListeners(resourceName, triggers);
      console.log('Removed sync listeners for %s %d', resourceName, id);
    }
  },

  /**
   * Sync callback. This will fetch data for the given model from the server and execute the user
   * defined callback when finished
   *
   * @param  {number} timestamp time the resource changed on the server
   */
  $sync: function $sync (id, callback, timestamp) {
    var resourceName = this.$name;
    var model = this.get(id);
    var previousTimestamp = _recordedTimestamps[resourceName + '-' + id];
    var updatedAt = previousTimestamp || model.get('updatedAt'); // time the local version of the model was last synced
    var lastSaved = new Date(updatedAt).getTime(); //convert to numeric time

    console.log('Remote last update @ %s. Local last saved @ %s. Checking if %s model %s needs to be synced', timestamp, lastSaved, resourceName, id);

    if (lastSaved < timestamp) {
      console.info('Syncing %s model %s', resourceName, id);

      this.find(id)
        .then(function () {
          console.log('Finished syncing %s %d', resourceName, id);

          return this.update(id, {'updatedAt': Date.now()});
        }.bind(this))
        .then(function (_model) {
          if (callback) {
            callback(_model);
          }
        });
    }

    _recordedTimestamps[resourceName + '-' + id] = timestamp;
  }
};


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/data/src/core/mixins/Sync.js